import { useEffect, useRef, useState } from "react";

const useAutoLogout = (onLogout, timeoutMinutes = 30, warningSeconds = 30) => {
  const timeoutRef = useRef(null);
  const warningRef = useRef(null);
  const countdownRef = useRef(null);

  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(warningSeconds);

  const clearAllTimers = () => {
    clearTimeout(timeoutRef.current);
    clearTimeout(warningRef.current);
    clearInterval(countdownRef.current);
  };

  const resetTimer = () => {
    clearAllTimers();
    setShowWarning(false);
    setCountdown(warningSeconds);

    const totalTimeout = timeoutMinutes * 60 * 1000;
    const warningTime = totalTimeout - warningSeconds * 1000;

    // Trigger the 30-sec warning popup
    warningRef.current = setTimeout(() => {
      setShowWarning(true);
      setCountdown(warningSeconds);

      // Start countdown (30 → 0)
      countdownRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);
          }
          return prev - 1;
        });
      }, 1000);
    }, warningTime);

    // Final logout trigger
    timeoutRef.current = setTimeout(() => {
      onLogout();
    }, totalTimeout);
  };

  useEffect(() => {
    const activityEvents = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];
    const handleActivity = () => resetTimer();

    activityEvents.forEach((e) => window.addEventListener(e, handleActivity));
    resetTimer(); // start timer

    return () => {
      activityEvents.forEach((e) =>
        window.removeEventListener(e, handleActivity)
      );
      clearAllTimers();
    };
  }, [onLogout, timeoutMinutes, warningSeconds]);

  return { showWarning, countdown, resetTimer, setShowWarning };
};

export default useAutoLogout;
